import { render } from "./PaperDisplayer.vue?vue&type=template&id=7d8acf4e&scoped=true"
import script from "./PaperDisplayer.vue?vue&type=script&lang=js"
export * from "./PaperDisplayer.vue?vue&type=script&lang=js"

import "./PaperDisplayer.vue?vue&type=style&index=0&id=7d8acf4e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3396806294/src/NewSmartDash/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8acf4e"]])

export default __exports__